import { useEffect, useRef, useState } from 'react';
import Script from 'next/script';
import styles from '../../styles/CompanyReviews.module.css';
import { useAppContext } from '../../context/shared';

const REVIEWS_COMPONENT_ID = 'badge-ribbon';

export default function CompanyReviews() {
  const [reviewsScriptLoaded, setReviewsScriptLoaded] = useState(false);
  const { locale } = useAppContext();

  useEffect(() => {
    if (reviewsScriptLoaded && window.reviewsBadgeRibbon) {
      const el = document.getElementById(REVIEWS_COMPONENT_ID);

      if (el) {
        el.innerHTML = '';
      }

      window.reviewsBadgeRibbon(REVIEWS_COMPONENT_ID, {
        store: 'tribu-box.com',
        size: 'small',
        lang: locale,
        mono: true,
      });
    }
  }, [locale, reviewsScriptLoaded]);

  return (
    <>
      <Script
        src="https://widget.reviews.io/badge-ribbon/dist.js"
        onLoad={() => setReviewsScriptLoaded(true)}
      />
      <div className={styles.wrapper} id={REVIEWS_COMPONENT_ID}></div>
    </>
  );
}